import { CfSeparatorProps } from "../types";
import { convertCfSpacersProps } from "utilities/cfPropTypes/cfSpacers";
import React from "react";
import Separator from "../index";

export const convertCfSeparatorProps = ({
  contentful_id,
  id,
  customClass,
  spacers,
}: CfSeparatorProps) => {
  return {
    customClass,
    ...convertCfSpacersProps(spacers),
  };
};

const CfSeparator = (props: CfSeparatorProps) => {
  return <Separator {...convertCfSeparatorProps(props)} />;
};

export default CfSeparator;
